import React from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import ProfileForm from '../../components/profile/ProfileForm';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useAuth } from '../../hooks/useAuth';
import { useProfile } from '../../hooks/useProfile';
import { theme } from '../../config/theme';

const AdminProfile = () => {
  const { user } = useAuth();
  const { updateProfile, loading } = useProfile();

  const handleSubmit = async (data) => {
    await updateProfile(data);
  };

  if (!user) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '800px', margin: '0 auto' }}>
        <h1 style={{ 
          fontSize: theme.typography.fontSize['3xl'], 
          fontWeight: theme.typography.fontWeight.bold, 
          marginBottom: theme.spacing.xl 
        }}>
          Admin Profile
        </h1>
        <ProfileForm user={user} onSubmit={handleSubmit} loading={loading} />
      </div>
    </MainLayout>
  );
};

export default AdminProfile;